export type BusinessSegment = 'employee' | 'workplace';

export const BUSINESS_SEGMENTS: readonly BusinessSegment[] = [
  'employee',
  'workplace',
];

export type SegmentAccess = {
  view: boolean;
  edit: boolean;
};

// `client_access` of the login payload: per business segment, whether the
// user may view and edit clients.
export type ClientAccessDto = Record<BusinessSegment, SegmentAccess>;

export type ClientAccess = Record<BusinessSegment, SegmentAccess>;
